import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, Params} from '@angular/router';
import { ScoreboardService } from "../services/scoreboard.service";
import { SocketService } from "../services/socket.service";
import { HelperService } from '../services/helper.service';

@Component({
  selector: 'app-qsrugby',
  templateUrl: './qsrugby.component.html',
  styleUrls: ['./qsrugby.component.css']
})
export class QsrugbyComponent implements OnInit {
  routeParams;
  results;
  connection;
  noData;
  messageDate;
  clock;
  games;

  constructor(private route: ActivatedRoute, private router: Router,
  private ss: ScoreboardService, private helper: HelperService, private socketService: SocketService) { }

  ngOnInit() {
    this.routeParams = this.route.params
      .subscribe((params: Params) => {
        this.socketService.sendTopic(+params['id']);
        this.results = this.ss
          .getLastScoreboardData(+params['id'])
          .subscribe(message => {
            this.connection = this.socketService.messages().subscribe(message => {
              this.noData = false;
              if(message['app'] !== 'qsrugby'){
                this.helper.redirectToComponent(message, this.router, params);
              }else{
                this.setData(message);
              }
            });
            if(!this.helper.isEmpty(message)){
              if(message['app'] !== 'qsrugby'){
                this.helper.redirectToComponent(message, this.router, params);
              }
              this.setData(message);
              this.noData = false;
            }
          });
      });
  }
  ngOnDestroy(): void {
    this.connection.unsubscribe();
    this.results.unsubscribe();
    this.routeParams.unsubscribe();
  }

  getGameName (name, shortName, team) {
    return name ? name : shortName ? shortName : team;
  }

  getTimeMatch ( time ) {
    let minutes = Math.floor(time / 60);
    let seconds = time - minutes * 60;
    let strString = seconds < 10 ? `0${seconds}`: seconds;
    return `${minutes}:${strString}`;
  }

  getHalves ( number ) {
    let result = '';
    switch(number) {
      case 1: {
        result = '1st Half';
        break;
      }
      case 2: {
        result = '2nd Half';
        break;
      }
      case 3: {
        result = 'Extra 1';
        break;
      }
      case 4: {
        result = 'Extra 2';
        break;
      }
      default: {
        result = '1st Half';
        break;
      }
    }
    return result;
  }

  setData (message){
    this.games = message['data']['games'];

  }


}



// WEBPACK FOOTER //
// ./src/app/qsrugby/qsrugby.component.ts